import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const [activeItem, setActiveItem] = useState(null);

  const toggleItem = (id) => {
    setActiveItem(activeItem === id ? null : id);
  };

  const faqItems = [
    {
      id: 'faq1',
      question: 'How do you recommend movies?',
      answer: ['We combine movie metadata, ratings, critic reviews, audience reception, streaming trends, and curated human insight to recommend only high-quality movies and series worth your time.', 'Our goal is simple: help you quickly discover the best content available on popular streaming platforms like Netflix, Max, Prime Video, and more.'],
    },
    {
      id: 'faq2',
      question: 'How current is your movie database?',
      answer: ['Our movie and series database is updated daily to keep recommendations fresh and relevant. In addition, featured titles and homepage recommendations are refreshed approximately every 30 minutes to highlight trending, newly added, and top-rated streaming content.'],
    },
    {
      id: 'faq3',
      question: 'How do you determine which streaming service a movie is available on?',
      answer: ['We use a combination of streaming metadata providers and manual verification by our small, but globally distributed, team to check where movies and series are available. This helps us provide more accurate streaming availability information across different regions and platforms.'],
    },
    {
      id: 'faq4',
      question: 'Can I contribute or suggest a movie?',
      answer: ['Absolutely! Community feedback is a huge part of CineRecs. If you’d like to suggest a movie, series, feature, or improvement, contact us at support@cinerecs.com and we’ll get back to you as soon as possible.'],
    },
    {
      id: 'faq5',
      question: 'Do you handle different regions for streaming availability?',
      answer: ['Yes. While our primary focus is currently the Americas (including the USA and LATAM countries), we are actively expanding support for additional regions worldwide.', 'You can also explore region-specific streaming recommendations, movie lists, and curated guides on the CineRecs Blog.'],
    },
    {
      id: 'faq6',
      question: 'Are there any costs associated with using the site?',
      answer: ['No. CineRecs is completely free to use. You can browse curated movie and series recommendations, discover hidden gems, and explore streaming availability at no cost.'],
    },
    {
      id: 'faq7',
      question: 'How can I get the best recommendations for my taste?',
      answer: ['For personalized recommendations, we recommend exploring our Find Your Movies section, designed to help you discover movies and series tailored to your preferences. You can also subscribe to the CineRecs newsletter for free monthly recommendations featuring the best movies and series on major streaming platforms. It’s a curated, no-spam newsletter built for people who genuinely love high-quality entertainment.'],
    }
  ];

  return (
    <div className="faq-page">
      <div className="faq-container">
        <div className="faq-header">
          <h1>Frequently Asked Questions</h1>
          <p>Find answers to common questions about our movie recommendation service</p>
        </div>
        
        <div className="faq-intro">
          <p>We combine <span className="highlight">movie metadata</span>, <span className="highlight">trailers</span>, and <span className="highlight">streaming availability</span> with both statistical analysis and human curation to help you find perfect movies to watch.</p>
        </div>
        
        <div className="faq-content">
          {faqItems.map((item) => (
            <FAQItem
              key={item.id}
              item={item}
              isActive={activeItem === item.id}
              onClick={() => toggleItem(item.id)}
            />
          ))}
        </div>
      </div>
      
      <div className="cta-section">
        <h3>Still have questions?</h3>
        <p>Our support team is here to help you find the perfect movie for any occasion.</p>
        <a className="cta-button" href="mailto:support@cinerecs.com">
          Contact Support
        </a>
      </div>
    </div>
  );
};

// FAQ Item Sub-component
const FAQItem = ({ item, isActive, onClick }) => {
  return (
    <div className={`faq-item ${isActive ? 'active' : ''}`} id={item.id}>
      <div className="faq-question" onClick={onClick}>
        {item.question}
        <span className="faq-toggle">{isActive ? '−' : '+'}</span>
      </div>
      <div className="faq-answer" style={{ maxHeight: isActive ? '500px' : '0' }}>
        {item.answer && 
            item.answer.map(
                (ans) => (
                    <p>{ans}</p>
                )
            )
        }
        
      </div>
    </div>
  );
};

export default FAQ;
